
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-16">
        <div className="container mx-auto px-6">
          <h1 className="text-5xl font-bold mb-6">Contact Yazan Al Homsi</h1>
          <p className="text-xl text-gray-300 max-w-3xl">
            Whether you're an entrepreneur with a sustainable venture, an investor seeking ESG opportunities, 
            or a media professional looking for expert commentary, Yazan Al Homsi welcomes your inquiry.
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Details */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-slate-900 mb-8">Get In Touch</h2>
              
              <div className="space-y-8">
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-4">Vancouver Office</h3>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-emerald-500 rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className="ri-building-line text-white"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Founders Round Capital</p>
                      <p className="text-gray-600">Vancouver, British Columbia, Canada</p>
                    </div>
                  </div>
                </div>
                
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-4">Dubai Office</h3>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className="ri-building-2-line text-white"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Catalyst Communications DMCC</p>
                      <p className="text-gray-600">Dubai, United Arab Emirates</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Professional Profiles */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-slate-900 mb-8">Professional Profiles</h2>
              
              <div className="space-y-6">
                <div className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-linkedin-fill text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-slate-900">LinkedIn</h3>
                    <p className="text-sm text-gray-600">Connect for professional network updates</p>
                    <a 
                      href="https://ae.linkedin.com/in/yazanhomsi" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-emerald-600 hover:text-emerald-700 text-sm cursor-pointer"
                    >
                      ae.linkedin.com/in/yazanhomsi
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-database-line text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-slate-900">Crunchbase</h3>
                    <p className="text-sm text-gray-600">View complete investment portfolio</p>
                    <a 
                      href="https://www.crunchbase.com/person/yazan-al-homsi" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-emerald-600 hover:text-emerald-700 text-sm cursor-pointer"
                    >
                      crunchbase.com/person/yazan-al-homsi
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-rocket-line text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-slate-900">F6S</h3>
                    <p className="text-sm text-gray-600">Startup ecosystem profile and funding opportunities</p>
                    <a 
                      href="https://www.f6s.com/yazan-al-homsi" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-emerald-600 hover:text-emerald-700 text-sm cursor-pointer"
                    >
                      f6s.com/yazan-al-homsi
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-newspaper-line text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-slate-900">Clippings</h3>
                    <p className="text-sm text-gray-600">Media coverage and press mentions</p>
                    <a 
                      href="https://www.clippings.me/yazanalhomsi" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-emerald-600 hover:text-emerald-700 text-sm cursor-pointer"
                    >
                      clippings.me/yazanalhomsi
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="w-12 h-12 bg-slate-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-user-line text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-slate-900">About.me</h3>
                    <p className="text-sm text-gray-600">Complete professional background</p>
                    <a 
                      href="https://yazanalhomsi.me" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-emerald-600 hover:text-emerald-700 text-sm cursor-pointer"
                    >
                      yazanalhomsi.me
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8">Ready to Connect?</h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            Yazan Al Homsi welcomes inquiries from entrepreneurs, investors, and media professionals.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="https://ae.linkedin.com/in/yazanhomsi" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-4 px-8 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Connect on LinkedIn
            </a>
            <a 
              href="https://www.crunchbase.com/person/yazan-al-homsi" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              View on Crunchbase
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
